import { getGlobalObject } from "./global";

const PREFIX = `[ Jupiter Logger ]`;

const global = getGlobalObject<Window>();

class Logger {
  private _isEnabled: boolean;

  constructor() {
    this._isEnabled = false;
  }

  public enable() {
    this._isEnabled = true;
  }

  public disable() {
    this._isEnabled = false;
  }

  public debug(...args: any[]) {
    if (!this._isEnabled) {
      return;
    }
    global.console.debug(`${PREFIX} [debug]: `, ...args);
  }

  public log(...args: any[]) {
    if (!this._isEnabled) {
      return;
    }
    global.console.log(`${PREFIX} [log]: `, ...args);
  }

  public warn(...args: any[]) {
    if (!this._isEnabled) {
      return;
    }
    global.console.warn(`${PREFIX} [warn]: `, ...args);
  }

  public error(...args: any[]) {
    if (!this._isEnabled) {
      return;
    }
    global.console.error(`${PREFIX} [error]: `, ...args);
  }
}

const logger = new Logger();

export { logger as Logger };
